// extracted by mini-css-extract-plugin
module.exports = {"coach-container":"coach-container","coach-item":"coach-item","avatar-container":"avatar-container","text":"text"};